import { sortBy } from "lodash";
import * as Permissions from "../../supportFunctions/Permissions";

export const LANGUAGE_PATH = "languages";
export const LIST_MANAGER_PATH = "list-manager/lists";

export type NavItemsType = {
  id: string;
  label: string;
  icon?: string;
  path: string;
  permission?: string[];
  flag?: string;
};

interface Capability {
  id?: string;
  name: string;
  displayName: string;
  permission?: string;
  flag?: string;
}

export const EHS_CONFIG_TYPES: Capability[] = [
  {
    name: LIST_MANAGER_PATH,
    displayName: "List Manager",
    permission: Permissions.canViewEhsConfig,
    flag: "showProductListManager",
  },
  {
    name: "Incident",
    displayName: "Incident",
  },
  {
    name: "Task",
    displayName: "Actions",
  },
  {
    name: "Audit",
    displayName: "Audit",
  },
  {
    name: "Moc",
    displayName: "Management of Change",
  },
  {
    name: "Training",
    displayName: "Training Management",
  },
  {
    name: "Risk",
    displayName: "Standard Job Safety Analysis",
  },
  {
    name: "SafetyMeeting",
    displayName: "Meetings",
  },
  {
    name: "Compliance",
    displayName: "Compliance Management",
  },
  {
    name: "Mappings",
    displayName: "Mappings",
  },
  {
    name: "Settings",
    displayName: "App Settings",
  },
  {
    name: "WebAppNavigation",
    displayName: "Core",
  },
  {
    name: "WorkerTasks",
    displayName: "Worker Tasks",
  },
  {
    name: LANGUAGE_PATH,
    displayName: "Languages",
  },
];

export const EHS_LANGUAGES: Capability[] = [
  {
    name: "Language_zh_CN",
    displayName: "Chinese",
  },
  {
    name: "Language_da",
    displayName: "Danish",
  },
  {
    name: "Language_nl",
    displayName: "Dutch",
  },
  {
    name: "Language_en",
    displayName: "English",
  },
  {
    name: "Language_fr",
    displayName: "French",
  },
  {
    name: "Language_de",
    displayName: "German",
  },
  {
    name: "Language_hu",
    displayName: "Hungarian",
  },
  {
    name: "Language_id",
    displayName: "Indonesian",
  },
  {
    name: "Language_it",
    displayName: "Italian",
  },
  {
    name: "Language_ja",
    displayName: "Japanese",
  },
  {
    name: "Language_ko",
    displayName: "Korean",
  },
  {
    name: "Language_pl",
    displayName: "Polish",
  },
  {
    name: "Language_pt",
    displayName: "Portuguese",
  },
  {
    name: "Language_ro",
    displayName: "Romanian",
  },
  {
    name: "Language_ru",
    displayName: "Russian",
  },
  {
    name: "Language_sk",
    displayName: "Slovak",
  },
  {
    name: "Language_es",
    displayName: "Spanish",
  },
  {
    name: "Language_sv",
    displayName: "Swedish",
  },
  {
    name: "Language_th",
    displayName: "Thai",
  },
  {
    name: "Language_tr",
    displayName: "Turkish",
  },
];

export const getNavItems = (
  userPermissions: Permissions.PermissionsFlagObjectType,
  flags: any
): NavItemsType[] => {
  const sorted = sortBy(mapToNavItems(EHS_CONFIG_TYPES), (app) => {
    // If the label is "List Manager", assign it to the bottom of the list
    return app.id === LIST_MANAGER_PATH ? "ZZZ" : app.label;
  });

  return sorted.filter((item) => {
    if (item.permission && item.permission.length > 0 && flags[item.flag]) {
      const hasPermission = Permissions.IsAllowed(
        item.permission,
        userPermissions
      );
      return hasPermission;
    }
    return true;
  });
};

function mapToNavItems(capabilities: Capability[]): NavItemsType[] {
  return filterFlaggedNavItems(capabilities).map((app) => ({
    id: app.name,
    label: app.displayName,
    path: `/ehs-configurations/${app.name}`,
    permission: app.permission ? [app.permission] : [],
    flag: app.flag,
  }));
}

function filterFlaggedNavItems(capabilities: Capability[]): Capability[] {
  return capabilities.filter((app) => {
    return !app.flag || app.name === LIST_MANAGER_PATH;
  });
}
